// framework/common/schemas/collections/pushSubscriptions.js
import { z } from "zod";

const PushSubscriptionSchema = z.object({
    _id: z.string().optional(),
    userId: z.string().describe("The AppBuilder user ID this subscription belongs to."),
    // The subscription object from the browser's Push API is complex and vendor-specific.
    // We store it as a generic object and only validate the parts we use.
    subscriptionObject: z.object({
        endpoint: z.string().url().describe("The unique endpoint URL provided by the push service."),
        keys: z.object({
            p256dh: z.string(),
            auth: z.string()
        })
    }).passthrough(), // Allow other properties
    channels: z.array(z.string()).default(['default']).describe("Topics the user is subscribed to."),
    createdAt: z.date().optional(),
});

export default PushSubscriptionSchema;